import { EventType } from '../../../../domain/Calendar/CalendarEvent';
import { withEventSubmit } from '../../../common/EventForm/withEventSubmit';
import { EditStoreEvent } from './EditStoreEventForm';
import { updateEvent } from '../../../../api/calendar';

export default withEventSubmit(EditStoreEvent, EventType.Store, updateEvent);
